import React, {Component} from 'react';
import { List, Toast, NavBar, Icon, WingBlank, Picker, WhiteSpace } from 'antd-mobile';
import Blank from '../components/Blank';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import ProfileView from '../components/ProfileView';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';
import { createForm } from 'rc-form';
import iconCoupon from '../medias/coupon.svg';
import '../styles/UserCouponPacket.css';

const history = require("history").createHashHistory()

class UserCouponPacket extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            couponDetail: {},
            packetRules: [],
            selectedSite: null,
            enableBuyPacket: true,
            deviceTypes: []
        }
    }

    componentDidMount() {
        this.couponCode = CommonUtils.resolveSearchParam(this.props.location, 'couponCode')
        this.loadInitData()
    }

    loadInitData = () => {
        this.loadDeviceTypes()
        this.loadCouponDetail(() => {
            this.loadCouponPacketRules()
        })
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadCouponDetail = (callback) => {
        this.setState({
            loading: true
        })
        DataFetcher.userCouponDetail({
            couponCode: this.couponCode
        }, {
            success: (resp) => {
                this.setState({
                    couponDetail: resp.data,
                    selectedSite: resp.data&&resp.data.activity&&resp.data.activity.siteIds?resp.data.activity.siteIds[0]:null
                }, () => {
                    callback&&callback()
                })
            },
            completed: () => {
                this.setState({
                    loading: false
                })
            }
        })
    }

    loadCouponPacketRules = () => {
        const { selectedSite } = this.state
        DataFetcher.couponPacketRules({
            couponCode: this.couponCode,
            siteId: selectedSite
        }, {
            success: (resp) => {
                this.setState({
                    packetRules: resp.data
                })
            }
        })
    }

    onSitePickerChange = (vals) => {
        this.setState({
            selectedSite: vals[0]
        }, () => {
            this.loadCouponPacketRules()
        })
    }

    handleBuyPacket = (packetRule) => {
        const { enableBuyPacket } = this.state
        if(!enableBuyPacket) {
            Toast.info('购买中')
            return;
        }

        this.doBuyPacket(packetRule)
    }

    doBuyPacket = (packetRule) => {
        this.setState({
            enableBuyPacket: false
        })
        Toast.info('支付跳转中')
        DataFetcher.buyCouponPacket(
            {
                gamePacket: packetRule.id,
                couponCode: this.couponCode
            }, {
                success: (resp) => {
                    CommonUtils.invokeWechatPay(resp.data, () => {
                        history.replace('/user')
                    })
                },
                completed: () => {
                    this.setState({
                        enableBuyPacket: true
                    })
                }
            }
        )
    }

    generateHeaderView() {
        const { couponDetail } = this.state;
        return (
            <div className="section-header">
                <div className="container-left">
                    <div className="fl wrapper-avatar">
                        <img src={iconCoupon} alt=""/>
                    </div>
                    <div className="fl wrapper-basic">
                        <div className="name word-ellipsis">{couponDetail.activity?couponDetail.activity.name:'套餐折扣'}</div>
                        <div className="brand word-ellipsis">{couponDetail.activity&&CommonUtils.isNotEmpty(couponDetail.activity.description)?couponDetail.activity.description:Constants.Strings.APP_NAME}</div>
                    </div>
                </div>
            </div>
        )
    }

    generateProfileView() {
        const { couponDetail } = this.state;
        let data = []
        data.push({label: '套餐折扣', value: couponDetail.record?`${couponDetail.record.discount}%`:'0'})
        data.push({label: '最低套餐', value: couponDetail.record&&couponDetail.record.bottomAmount?`￥${couponDetail.record.bottomAmount}`:'不限'})
        data.push({label: '最高套餐', value: couponDetail.record&&couponDetail.record.topAmount?`￥${couponDetail.record.topAmount}`:'不限'})

        return <ProfileView data={data}/>
    }

    generateSiteView = () => {
        const { couponDetail, selectedSite } = this.state
        const sitePickerData = []
        if(couponDetail.activity && couponDetail.activity.siteIds && couponDetail.activity.siteIds.length) {
            let siteIds = couponDetail.activity.siteIds
            let siteNames = couponDetail.activity&&couponDetail.activity.siteNames?couponDetail.activity.siteNames:[]
            for(let i = 0; i < siteIds.length; i++) {
                if(siteNames[i]) {
                    sitePickerData.push({value: siteIds[i], label: siteNames[i]})
                }
            }
        }

        return (
            <WingBlank size="md">
                <div className='section-site'>
                    <Picker 
                        cols={1}
                        value={[selectedSite]}
                        onOk={this.onSitePickerChange}
                        data={sitePickerData}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-youxiyouxiji' style={{size: 20}}/>
                            <span> 游戏套餐</span>
                        </List.Item>
                    </Picker>
                    <WhiteSpace/>
                </div>
            </WingBlank>
        )
    }

    generatePacketView = () => {
        const { packetRules, couponDetail } = this.state

        if(couponDetail && couponDetail.record && couponDetail.record.status !== 'TO_EXCHANGE') {
            return (
                <div className='section-packet'>
                    <div className='tip'>优惠券已使用过！</div>
                </div>
            )
        }

        if(!packetRules || !packetRules.length) {
            return (
                <div className='section-packet'>
                    <div className='tip'>无符合条件的套餐！</div>
                </div>
            )
        }

        return (
            <div className="section-packet">
                {packetRules.map((rule, index) => {
                    let useCouponPrice = rule.couponPrice&&rule.couponPrice>0
                    let ruleName = rule.name ? rule.name : `${rule.gameMinutes}分钟套餐`
                    let ruleTip = rule.description ? rule.description : ruleName
                    let ruleLabel = rule.label
                    return (
                        <div key={rule.id} className='packet-rule' onClick={() => {this.handleBuyPacket(rule)}}>
                            <div className='description'>
                                <div className='name word-ellipsis'>
                                    <span>{ruleName}</span>
                                    <span className={`rule-tag${ruleLabel?'':' hidden'}`}>{ruleLabel}</span>
                                </div>
                                <div className='tip word-ellipsis'>{ruleTip}</div>
                            </div>
                            <div className="price">
                                <div className={`original${useCouponPrice?'':' hidden'}`}>￥{rule.price}</div>
                                <div className='real'>￥{useCouponPrice?rule.couponPrice:rule.price}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    generateDeviceView() {
        const { couponDetail } = this.state
        if(!couponDetail || !couponDetail.activity || !couponDetail.activity.deviceType) {
            return
        }

        return (
            <div className='section-device'>
                <div className='name word-ellipsis'>
                    <i className='iconfont icon-diannao'></i>
                    &nbsp;&nbsp;
                    <span>{CommonUtils.resolveDictText(couponDetail.activity.deviceType, this.state.deviceTypes, 'code', 'name')}</span>
                </div>
            </div>
        )
    }

    doRenderView() {
        return (
            <div className="page-user-coupon-packet">
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    style={{borderBottom: '1px solid #eeeeee'}}
                >
                    套餐折扣券
                </NavBar>
                {this.generateHeaderView()}
                <Blank/>
                {this.generateProfileView()}
                <Blank/>
                {this.generateSiteView()}
                {this.generatePacketView()}
                {this.generateDeviceView()}
            </div>
        )
    }

    render() {
        const { loading } = this.state;

        if(loading) {
            return <LoadingPlaceholder/>;
        } else {
            return this.doRenderView()
        }
    }
}

export default createForm()(UserCouponPacket);


// WEBPACK FOOTER //
// ./src/modules/UserCouponPacket.js